import './assets/js/flexible.debug.js'
import Vue from 'vue'
import Mint from 'mint-ui'
import router from './router'
// import Fastclick from 'fastclick'
import App from './App'

import './assets/css/reset.css'
import './assets/css/style.css'
import './assets/scss/common.scss'
import './assets/js/talkingdata.js'
import './assets/js/wx_share.js'

// Fastclick.attach(document.body)
Vue.use(Mint)

new Vue({
  render: f => f(App),
  router
}).$mount('#App')

Vue.filter('money', function (price) {
  var _str_price = price + ''
  var _arr = _str_price.split('.')
  if (_arr.length === 1) {
    _str_price += '.00'
  } else {
    if (_arr[1].length === 1) {
      _str_price += '0'
    }
  }
  return _str_price
})

Vue.directive('drag', {
  bind: function (el, binding) {
    let oDiv = el
    oDiv.ontouchstart = function (e) {
      // 鼠标按下，计算当前元素距离可视区的距离
      let disY = e.touches[0].clientY - document.getElementById('orderDetail').offsetTop
      document.ontouchmove = function (e) {
        let t = e.touches[0].clientY - disY
        // 将此时的位置传出去
        binding.value({
          top: t
        })
      }
      document.ontouchend = function (e) {
        document.ontouchstart = null
        document.ontouchmove = null
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js